import { FormationDetailProps } from '@/types/formation';

export const daeFormation: FormationDetailProps = {
  id: '26',
  title: 'Formation DAE',
  description: 'Apprenez à utiliser un Défibrillateur Automatique Externe (DAE) de manière efficace et sécurisée pour sauver des vies en cas d\'arrêt cardiaque.',
  duration: '3 heures',
  category: 'Secourisme',
  imageSrc: '/images/formations/dae.webp',
  slug: 'dae',
  reference: 'F-DAE',
  price: 'Sur devis – nous contacter',
  targetAudience: 'Tout public, salariés d\'entreprise, professionnels de santé, établissements recevant du public (ERP)',
  prerequisites: 'Aucun prérequis particulier',
  objectives: [
    'Connaître les principes de base de la réanimation cardio-pulmonaire (RCP)',
    'Savoir utiliser un défibrillateur automatisé externe (DAE)',
    'Mettre en œuvre la chaîne de survie',
    'Agir efficacement face à un arrêt cardiaque',
    'Appliquer les gestes de réanimation de base'
  ],
  program: [
    {
      title: 'Théorie et réglementation',
      items: [
        'Les chiffres clés de l\'arrêt cardiaque',
        'La chaîne de survie',
        'Réglementation relative à l\'utilisation des DAE',
        'Présentation du matériel (DAE, électrodes, etc.)'
      ]
    },
    {
      title: 'Mise en pratique',
      items: [
        'Reconnaître un arrêt cardiaque',
 'Réaliser les gestes de réanimation (massage cardiaque, ventilation)',
 'Utilisation du DAE en toute sécurité',
 'Mise en situation pratique avec cas concrets'
      ]
    }
  ],
  pedagogicalMethods: [
    'Apports théoriques',
    'Démonstrations pratiques',
    'Mises en situation',
    'Échanges avec les participants'
  ],
  evaluationMethods: [
    'Évaluation continue des acquis pratiques',
    'Mise en situation d\'urgence simulée'
  ],
  certification: 'Attestation de formation à l\'utilisation du DAE',
  registrationProcess: [
    'Inscription possible jusqu\'à 48h avant la formation (sous réserve de places disponibles)',
    'Groupe de 4 à 10 participants maximum'
  ],
  accessibilityCriteria: 'Formation accessible aux personnes en situation de handicap. Nous contacter pour adapter la formation selon les besoins spécifiques.',
  formatterInfo: {
    name: 'Sébastien DAVRAINVILLE - SDPSI Formation',
    phone: '06.22.61.04.09',
    email: 'sdpsiformation@orange.fr',
    website: 'www.sdpsi-formations.fr'
  }
};
